import { render, staticRenderFns } from "./ossMoreFile.vue?vue&type=template&id=68df8038&"
import script from "./ossMoreFile.vue?vue&type=script&lang=js&"
export * from "./ossMoreFile.vue?vue&type=script&lang=js&"
import style0 from "./ossMoreFile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports